module.exports = __webpack_public_path__ + "static/media/13S.84ea31d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/13S.svg
// module id = 48
// module chunks = 0